import { Call, FacebookRounded, Instagram } from "@mui/icons-material"
import { Avatar, Box, Button, Container, IconButton, } from "@mui/material"
import { Zoom } from '../../../../../../../../../core/global/Zoom';
import Currency from 'react-currency-format';

export const Preview = ({inputs}) => {
    const partialAmount = () => {
        if (inputs.partial.value !== '') {
            return parseFloat(inputs.partial.value).toFixed(2)
        }else{
            return  0 
        }    
    }
    return (
        <Zoom>
            <Container sx={{ width: 'fit-content', height: '100%', display: 'flex', flexDirection: 'column', bgcolor: '#FFFFFF', p: '24px', borderRadius: '12px'}} className="overflowY">
                <Box display="flex" width='1080px' minHeight="70vh" height="100%"  bgcolor="#F7F9F6" className="overflowY">
                    <Box width="50%"  sx={{backgroundImage: `url(${inputs.ft_img.object})`, backgroundSize: 'cover', height: '100%', maxHeight: '100vh', backgroundPosition: 'center', backgroundRepeat: 'no-repeat',}} >
                        <Box p={4} display="flex" alignItems="center" gap="8px">
                            <Avatar src={inputs.logo.object} alt="logo" variant="rounded" sx={{width: 60, height: 60}} />
                            <Box fontSize={{ md: 22, lg: 45}} fontWeight={600} flexWrap="wrap" sx={{wordBreak: 'break-word', textShadow: '-2px 1px 2px #fff'}} color="#FF0000">
                                {inputs.title.value}
                            </Box>
                        </Box>
                    </Box>
                    <Box width="50%" className="overflowY" boxShadow={10} sx={{backgroundImage: `url(${inputs.bg.object})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat',}} >
                        <Box>
                            <Box fontSize={{md: 24, lg: 32}} fontWeight={600} textAlign="center" p={2} color="#F4F9FF" flexWrap="wrap" sx={{wordBreak: 'break-word'}}>
                                {inputs.promo_caption.value}
                            </Box>
                            <Box py={5}>
                                <Box display="flex" alignItems="center" justifyContent="center" gap="16px" fontSize={{md: 28, lg: 34}} color="#F4F9FF" fontWeight={700} bgcolor={inputs.price_bg.value} py={2}>
                                    <Box>₱
                                        {
                                            inputs.discount_percent.value !== '.' && inputs.discount_percent.value !== '' && inputs.reg_price.value !== '' ? 
                                                Number((parseFloat(inputs.reg_price.value.replace(/,(?=\d{3})/g, '')) - (parseFloat(inputs.reg_price.value.replace(/,(?=\d{3})/g, '')) * (parseFloat(inputs.discount_percent.value) / 100))).toFixed(2) ).toLocaleString()
                                            : 
                                                0
                                        }
                                    </Box> 
                                    <Box>only</Box> 
                                </Box>
                                <Box display="flex" alignItems="center" justifyContent="center" gap="16px" fontSize={{md: 18, lg: 20}} color="#F4F9FF">
                                    <Box>Regular Price:</Box> 
                                    <Box>₱ {inputs.reg_price.value}</Box> 
                                </Box>
                                {
                                    inputs.partial.toggled && 
                                        <Box display="flex" flexDirection="column"  alignItems="center" fontSize={{md: 24, lg: 28}} fontWeight={700} color="#F4F9FF">
                                            <Box>Partial Payment</Box>
                                            <Box>
                                                ₱ <Currency value={partialAmount()} displayType={'text'} thousandSeparator={true} prefix={''} />
                                            </Box>
                                        </Box>
                                }
                            </Box>
                            <Box flexWrap="wrap" sx={{wordBreak: 'break-word'}} color="#F4F9FF" px={5}>
                                {
                                    inputs.promo_details.map((v, k) => (
                                        <Box display="flex" alignItems="baseline" justifyContent="center" fontSize={{md: 18, lg: 24}} key={k}>
                                            <Box>•</Box>
                                            <Box>{v.value}</Box>
                                        </Box>
                                    ))
                                }
                            </Box>
                        </Box>
                        <Box px={4} py={2} >
                            <Box display="flex" justifyContent="center">
                                <Box component={Button} variant="contained" fullWidth disableElevation borderRadius="16px" 
                                    bgcolor="#FFA200"
                                    sx={{':hover': { bgcolor: "#FFA200" }, fontSize: 22, fontWeight: 600, textTransform: 'uppercase'}}
                                >
                                    {inputs.button_caption.value}
                                </Box>
                            </Box>
                            
                            {
                                inputs.text_promo.show && <Box textAlign="center" color="#F4F9FF"> {inputs.text_promo.value} </Box>
                            }
                        </Box>
                    </Box>
                </Box>
                <Box display="flex" justifyContent="center" alignItems="center" py={2} gap="8px" bgcolor="#FFA200" fontWeight={600}>
                    <Box color="#FF0000">{inputs.contact_num.value}</Box>
                    <Call sx={{ fontSize: 30 , color: '#FF0000'}} />
                    <IconButton sx={{p: '0px'}}>
                        <FacebookRounded sx={{ color: '#FF0000', fontSize: 30 }} />
                    </IconButton>
                    <IconButton sx={{p: '0px'}}>
                        <Instagram sx={{ color: '#FF0000 ', fontSize: 30 }} />
                    </IconButton>
                    <Box color="#FF0000">{inputs.website.value}</Box>
                </Box>
            </Container>
         </Zoom>
        // <Box height="100%" width="100%" display="flex" flexDirection="column" className="overflowY">
        //     <Box height="100%" width="100%" display="flex" className="overflowY">
        //         <Box width="50%"  sx={{backgroundImage: `url(${inputs.ft_img.object})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat',}} >
        //             <Box p={4} display="flex" alignItems="center" gap="8px">
        //                 <Avatar src={inputs.logo.object} alt="logo" variant="rounded" sx={{width: 60, height: 60}} />
        //                 <Box fontSize={{ md: 22, lg: 45}} fontWeight={600} flexWrap="wrap" sx={{wordBreak: 'break-word', textShadow: '-2px 1px 2px #fff'}} color="#FF0000">
        //                     {inputs.title.value}
        //                 </Box>
        //             </Box>
        //         </Box>
        //         <Box width="50%" className="overflowY" boxShadow={10} sx={{backgroundImage: `url(${inputs.bg.object})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat',}} >
        //             <Box>
        //                 <Box fontSize={{md: 24, lg: 32}} fontWeight={600} textAlign="center" p={2} color="#F4F9FF" flexWrap="wrap" sx={{wordBreak: 'break-word'}}>
        //                     {inputs.promo_caption.value}
        //                 </Box>
        //                 <Box py={5}>
        //                     <Box display="flex" alignItems="center" justifyContent="center" gap="16px" fontSize={{md: 28, lg: 34}} color="#F4F9FF" fontWeight={700} bgcolor={inputs.price_bg.value} py={2}>
        //                         <Box>₱
        //                             {
        //                                 inputs.discount_percent.value !== '.' && inputs.discount_percent.value !== '' && inputs.reg_price.value !== '' ? 
        //                                     Number((parseFloat(inputs.reg_price.value.replace(/,(?=\d{3})/g, '')) - (parseFloat(inputs.reg_price.value.replace(/,(?=\d{3})/g, '')) * (parseFloat(inputs.discount_percent.value) / 100))).toFixed(2) ).toLocaleString()
        //                                 : 
        //                                     0
        //                             }
        //                         </Box> 
        //                         <Box>only</Box> 
        //                     </Box>
        //                     <Box display="flex" alignItems="center" justifyContent="center" gap="16px" fontSize={{md: 18, lg: 20}} color="#F4F9FF">
        //                         <Box>Regular Price:</Box> 
        //                         <Box>₱ {inputs.reg_price.value}</Box> 
        //                     </Box>
        //                     {
        //                         inputs.partial.toggled && 
        //                             <Box display="flex" flexDirection="column"  alignItems="center" fontSize={{md: 24, lg: 28}} fontWeight={700} color="#F4F9FF">
        //                                 <Box>Partial Payment</Box>
        //                                 <Box>
        //                                     ₱ <Currency value={partialAmount()} displayType={'text'} thousandSeparator={true} prefix={''} />
        //                                 </Box>
        //                             </Box>
        //                     }
        //                 </Box>
        //                 <Box flexWrap="wrap" sx={{wordBreak: 'break-word'}} color="#F4F9FF" px={5}>
        //                     {
        //                         inputs.promo_details.map((v, k) => (
        //                             <Box display="flex" alignItems="baseline" justifyContent="center" fontSize={{md: 18, lg: 24}} key={k}>
        //                                 <Box>•</Box>
        //                                 <Box>{v.value}</Box>
        //                             </Box>
        //                         ))
        //                     }
        //                 </Box>
        //             </Box>
        //             <Box px={4} py={2} >
        //                 <Box display="flex" justifyContent="center">
        //                     <Box component={Button} variant="contained" fullWidth disableElevation borderRadius="16px" 
        //                         bgcolor="#FFA200"
        //                         sx={{':hover': { bgcolor: "#FFA200" }, fontSize: 22, fontWeight: 600, textTransform: 'uppercase'}}
        //                     >
        //                         {inputs.button_caption.value}
        //                     </Box>
        //                 </Box>
                        
        //                 {
        //                     inputs.text_promo.show && <Box textAlign="center" color="#F4F9FF"> {inputs.text_promo.value} </Box>
        //                 }
        //             </Box>
        //         </Box>
        //     </Box>
        //     <Box display="flex" justifyContent="center" alignItems="center" py={2} gap="8px" bgcolor="#FFA200" fontWeight={600}>
        //         <Box color="#FF0000">{inputs.contact_num.value}</Box>
        //         <Call sx={{ fontSize: 30 , color: '#FF0000'}} />
        //         <IconButton sx={{p: '0px'}}>
        //             <FacebookRounded sx={{ color: '#FF0000', fontSize: 30 }} />
        //         </IconButton>
        //         <IconButton sx={{p: '0px'}}>
        //             <Instagram sx={{ color: '#FF0000 ', fontSize: 30 }} />
        //         </IconButton>
        //         <Box color="#FF0000">{inputs.website.value}</Box>
        //     </Box>
        // </Box>
    )
}
